/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React, { Component } from 'react'
import AlertModal from 'generic/dialog/AlertModal'

class ImageDisplay extends Component {
  render() {
    const { isOpen, onClose, imageUrl, errorMessage } = this.props

    return (
      <AlertModal
        open={isOpen}
        type="CLOSE"
        handleConfirm={onClose}
        contentStyle={{ position: 'absolute', top: '5%', left: '10%', transform: 'translate(0, 0)', maxWidth: '50%', width: 'auto' }}
        bodyStyle={{ paddingBottom: 0 }}
        style={{ display: 'flex', alignItems: 'start', justifyContent: 'flex-start', paddingTop: 0 }}
        autoScrollBodyContent={true}
      >
        {errorMessage ? 
          <div style={{ color: 'red', textAlign: 'center', padding: '20px' }}>
            {errorMessage}
          </div>
           : (
        <img
          style={{ width: '100%' }}
          src={imageUrl}
          alt=""
        />
        )}
      </AlertModal>
    )
  }
}

export default ImageDisplay


// WEBPACK FOOTER //
// ./src/components/common/ImageDisplay.js